export default "__VITE_ASSET__byvXP6_L__"